import './app';
import './integration/resultsIntegrationController';
import './resultsController';

export default '7Terminal.Results';
